// extracted by mini-css-extract-plugin
module.exports = {"details":"detailsList_details__3WCUw","detailsItem":"detailsList_detailsItem__1c37_","name":"detailsList_name__2R1Vw","value":"detailsList_value__2l3tk"};